export const SHAPES = {
    SQUARE: 'square',
    CIRCLE: 'circle'
} as const;

export const COLORS = {
    WHITE: 'white',
    GREEN: 'green',
    BLUE: 'blue'
} as const;
